import { registerPlugin } from '@capacitor/core';
import { ChargingSessionLivePlugin } from './charging-session-live.types';

export const ChargingSessionLive = registerPlugin<ChargingSessionLivePlugin>('ChargingSessionLive');
